"use client"

import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'
import { LocalShareButtons } from '@/components/blocks/local-share-buttons'

interface ZipPageClientProps {
  zipcode: string
  cityName: string
  citySlug: string
  stateName: string
  stateCode: string
  utilityName: string
  rateCents: number
  fisScore?: number
}

export function ZipPageClient({
  zipcode,
  cityName,
  citySlug,
  stateName,
  stateCode,
  utilityName,
  rateCents,
  fisScore
}: ZipPageClientProps) {
  const posthog = usePostHog()

  // Track page view with hyper-local data
  useEffect(() => {
    if (posthog) {
      posthog.capture('local_zip_viewed', {
        zip_code: zipcode,
        city_name: cityName,
        city_slug: citySlug,
        state_code: stateCode,
        state_name: stateName,
        utility_name: utilityName,
        electricity_rate_cents: rateCents,
        fis_score: fisScore,
        page_type: 'zip'
      })
    }
  }, [posthog, zipcode, cityName, citySlug, stateCode, stateName, utilityName, rateCents, fisScore])

  const locationName = `${cityName}, ${stateName} (${zipcode})`

  return (
    <div className="mb-6">
      <LocalShareButtons
        locationName={locationName}
        variant="top"
        fisScore={fisScore}
        electricityRate={rateCents}
      />
    </div>
  )
}

// Bottom share section
export function ZipPageShareBottom({
  zipcode,
  cityName,
  citySlug,
  stateName,
  stateSlug,
  rateCents
}: {
  zipcode: string
  cityName: string
  citySlug: string
  stateName: string
  stateSlug: string
  rateCents: number
}) {
  const locationName = `${cityName}, ${stateName} (${zipcode})`

  return (
    <div className="mt-8 pt-6 pb-8 border-t border-gray-200">
      <LocalShareButtons
        locationName={locationName}
        variant="bottom"
        electricityRate={rateCents}
      />
    </div>
  )
}
